import { useState, useCallback, useEffect } from 'react';

type TUseDialogVisibility = (modalVisibility?: boolean) => {
  isOpened: boolean;
  handleOpen: () => void;
  handleClose: () => void;
};

export const useDialogVisibility: TUseDialogVisibility = (
  modalVisibility = false,
) => {
  const [isOpened, setOpen] = useState<boolean>(modalVisibility);
  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);
  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);
  return {
    isOpened,
    handleOpen,
    handleClose,
  };
};

type TUseDialogWithDataReturn = {
  isOpened: boolean;
  handleOpen: () => void;
  closeModal: () => void;
  setData: (...data: any) => void;
  data: any;
};

export function useDialogWithData<T>(): TUseDialogWithDataReturn {
  const { isOpened, handleOpen, handleClose } = useDialogVisibility();
  const [data, setData] = useState<T | undefined>(undefined);

  const closeModal = useCallback(() => {
    setData(undefined);
  }, []);

  useEffect(() => {
    if (data) {
      handleOpen();
    } else {
      handleClose();
    }
  }, [handleOpen, handleClose, data]);

  return {
    isOpened,
    handleOpen,
    closeModal,
    data,
    setData,
  };
}
